export var MediaTouchpoint;
(function (MediaTouchpoint) {
    MediaTouchpoint["MOBILE"] = "MOBILE";
    MediaTouchpoint["TABLET"] = "TABLET";
    MediaTouchpoint["DESKTOP"] = "DESKTOP";
})(MediaTouchpoint || (MediaTouchpoint = {}));
//# sourceMappingURL=types.js.map